/** @jsx jsx */
import { memo } from 'react';
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button/standard-button';
import { itemWrapperStyles } from '../internal/styles';

var noop = function noop() {};

var EllipsisItem = /*#__PURE__*/memo(function (props) {
  var _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? noop : _props$onClick,
      testId = props.testId,
      label = props.label;
  return jsx("li", {
    css: itemWrapperStyles
  }, jsx(Button, {
    appearance: "subtle-link",
    spacing: "none",
    testId: testId,
    onClick: onClick,
    "aria-label": label
  }, "\u2026"));
});
export default EllipsisItem;